var _path, _g, _path2, _path3, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePhotoGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4619_18433)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4619_18433",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V19.92H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4619_18433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23.2008C18.1856 23.2008 23.2 18.1864 23.2 12.0008C23.2 5.81519 18.1856 0.800781 12 0.800781C5.81446 0.800781 0.800049 5.81519 0.800049 12.0008C0.800049 18.1864 5.81446 23.2008 12 23.2008Z",
    fill: "#9F9F9F"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 13.8016C14.5404 13.8016 16.5999 11.7421 16.5999 9.20156C16.5999 6.66105 14.5404 4.60156 11.9999 4.60156C9.45939 4.60156 7.3999 6.66105 7.3999 9.20156C7.3999 11.7421 9.45939 13.8016 11.9999 13.8016Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4619_18433",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.2008C18.1856 23.2008 23.2 18.1864 23.2 12.0008C23.2 5.81519 18.1856 0.800781 12 0.800781C5.81446 0.800781 0.800049 5.81519 0.800049 12.0008C0.800049 18.1864 5.81446 23.2008 12 23.2008Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4619_18433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 30.2008C16.5288 30.2008 20.2 26.5295 20.2 22.0008C20.2 17.472 16.5288 13.8008 12 13.8008C7.47131 13.8008 3.80005 17.472 3.80005 22.0008C3.80005 26.5295 7.47131 30.2008 12 30.2008Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4619_18433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePhotoGray);
export default __webpack_public_path__ + "static/media/profile_photo_gray.1d071592407ac3c11c632392b55c0d99.svg";
export { ForwardRef as ReactComponent };